import {
    Button,
    Group,
} from '@mantine/core';
import {
    AiOutlineCheckCircle,
    AiOutlineStop,
} from 'react-icons/ai';

import {
    ActionStatus,
    TestingAction,
} from '../types.ts';
import {useSetTestingActionStatusMutation} from '../hooks/useTestingActionsQuery.ts';
import {useVerifiedPermissions} from '../../../hooks/useVerifiedPermissions.ts';
import {rbacActions} from '../../../config/rbac/actions.ts';

// Status is NOT a field on the edit form. Transitions are explicit affordances
// that call setActionStatus — a conditional write on the server. If a transition
// is illegal the mutation fails and the error is surfaced by notifyError (wired
// in useSetTestingActionStatusMutation), never swallowed.
//
// Offered transitions:
//   DRAFT   -> ACTIVE  (Activate)
//   ACTIVE  -> RETIRED (Retire)
//   RETIRED -> ACTIVE  (Reactivate) — offered because only the server decides
//                       whether it is legal; if it is not, the user sees why.
export const SetStatusButtons = ({record}: { record: TestingAction }) => {

    const {allowedActions} = useVerifiedPermissions();
    const setStatusMutation = useSetTestingActionStatusMutation();

    if (!allowedActions.includes(rbacActions.SetTestingActionStatus)) {
        return null;
    }

    const handleSetStatus = (targetStatus: ActionStatus) => {
        setStatusMutation.mutate({
                                     id: record.id,
                                     targetStatus: targetStatus,
                                 });
    };

    const buttons = [];

    if (record.status !== ActionStatus.ACTIVE) {
        buttons.push(
            <Button
                key='activate'
                variant='light'
                color='green'
                leftSection={<AiOutlineCheckCircle/>}
                loading={setStatusMutation.isPending}
                onClick={() => handleSetStatus(ActionStatus.ACTIVE)}
            >
                {record.status === ActionStatus.RETIRED ? 'Reactivate' : 'Activate'}
            </Button>
        );
    }

    if (record.status !== ActionStatus.RETIRED) {
        buttons.push(
            <Button
                key='retire'
                variant='light'
                color='orange'
                leftSection={<AiOutlineStop/>}
                loading={setStatusMutation.isPending}
                onClick={() => handleSetStatus(ActionStatus.RETIRED)}
            >
                Retire
            </Button>
        );
    }

    if (buttons.length === 0) {
        return null;
    }

    return <Group gap={'xs'}>{buttons}</Group>;
};
